import { reCAPTCHAv3, i18n } from "commonAssets/js/constants";
import { FormBase } from "commonAssets/components/FormBase";
import { modal } from "./modal.js";

export function submitContactForm() {
    const formClaim = new FormBase();
    const api = apigClientFactory.newClient(formClaim.config);
    const reason = document.getElementById("reason").value;
    const messageField = document.getElementById("message");
    const rawMessage = messageField ? messageField.value : "";
    const first_name = document.getElementById("first_name").value;
    const last_name = document.getElementById("last_name").value;
    const email_address = document.getElementById("email_address").value;
    const phone_number_1 = document.getElementById("phone_number_1").value;
    const claim_id_input = document.getElementById("claim_id");
    const claim_id = claim_id_input ? claim_id_input.value.trim() : "";
    const form_elements = [
        reason,
        rawMessage,
        first_name,
        last_name,
        email_address,
        phone_number_1,
    ];

    function toggleSubmitBtn() {
        const submitBtn = $("#submitContactFormBtn");
        if (submitBtn.prop("disabled")) {
            submitBtn.prop("disabled", false);
            submitBtn.html(i18n.getTranslation("submit_btn"));
        } else {
            submitBtn.prop("disabled", true);
            submitBtn.html(
                `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${i18n.getTranslation("submitting")}`
            );
        }
    }

    toggleSubmitBtn();

    // check to make sure these are all set
    if (form_elements.some((element) => !element)) {
        alert(i18n.getTranslation("contact_us_fill_required_fields"));
        toggleSubmitBtn();
        return;
    }
    try {
        grecaptcha.enterprise
            .execute(reCAPTCHAv3, { action: "submit" })
            .then((token) => {
                const ticket = {};
                ticket.token = token;
                ticket.domain = formClaim.hostname();
                ticket.subject = reason;
                const message = claim_id
                    ? `${rawMessage}\n\n${i18n.getTranslation(
                          "claim_id_if_known"
                      )}: ${claim_id}`
                    : rawMessage;
                ticket.contact = {
                    reason: reason,
                    message,
                    first_name,
                    last_name,
                    email_address,
                    phone_number_1,
                };

                api["zendeskTicketPost"]({}, ticket).then(
                    async function (result) {
                        // Check for error message
                        if (result.data.error) {
                            console.log(result.data.error);
                            alert(result.data.error);
                            toggleSubmitBtn();
                            return;
                        }

                        toggleSubmitBtn();
                        // alert(i18n[userLanguage].contact_us_success);
                        // TODO: REMOVE JQUERY FROM CORE!!!!!!!!!!!
                        $(".modal-backdrop").remove();
                        $(".modal").remove();

                        modal(
                            i18n.getTranslation("message"),
                            i18n.getTranslation("contact_us_success")
                        );
                    }
                );
            });
    } catch (error) {
        // Handle error
        toggleSubmitBtn();
        console.error("An error occurred while sending your message:", error);
        alert(i18n.getTranslation("contact_us_error_while_sending"));
    }
}
